export const familyAccount ={
    HEB: {

        myFamily: "המשפחה שלי",
        inviteMembers: "הזמנת חברי משפחה",
        inviteSuccessText: {
            header: "הזמנה נשלחה בהצלחה",
            details: "הזמנה נשלחה ל:", 
            button: "סגור",
        },
        inviteFailText: {
            header: "שליחת הזמנה נכשלה",
            details: "שליחת הזמנה נכשלה ל", 
            button: "סגור",
        },
        familyName: "שם המשפחה",
        inviteButton: "הזמן",
        joinedOn: "הצטרף בתאריך",
        familyMembersTitle: " חברי המשפחה שלי",
        family: "משפחת",
        youDontBelongToAFamily: " אינך משוייך כרגע למשפחה, כדי לייצר משפחה - שלח הזמנה או קבל ואשר הזמנה נכנסת  ",
        save: "שמור",
        editFamilyName: "עריכת שם משפחה",
        invitedOn: "הוזמן בתאריך",
        pendingInvites: "הזמנות פתוחות ששלחתי",
        incomingFamilyRequest: "הוזמנת למשפחת",
        by: "על ידי",
        rejectedInvite: "הזמנה נדחתה למשפחת",
        errorRejectingInvite: "שגיאה בדחיית הזמנה למשפחת",
        acceptedInvite: "הצטרפת בהצלחה למשפחת",
        errorAcceptingInvite: "שגיאה באישור הזמנה למשפחת",
        reject: "דחה",
        accept: "אשר",
        familyInvite:{
            header: "הוספת התא המשפחתי",
            body: "כאן תוכלו להוסיף את בן או בת הזוג של התא המשפחתי על מנת להתנהל כלכלית יחד. שלחו הזמנה ובקשו מבן או בת הזוג להתחברת לאפליקציה באמצעות אותה כתובת מייל שהזמנתם. ניתן לבטל את השיתוף בכל עת.",
            checkboxText: "אני מאשר/ת כי אני משתפ/ת את המידע הפיננסי שלי על פי החלטתי עם אדם איתו אני מקיימ/ת משק בית ו/או תא משפחתי בלבד.",
            familyVerificationError: "יש לאשר את הסעיף כדי להמשיך",
        },
        familyInviteScreen: {
            title: "הוזמנת להצטרף למשפחה!",
            invitedBy: "הוזמנת על ידי",
            toJoinFamily: "להצטרף למשפחת",
            premiumBenefit: "בקבלת ההזמנה תקבל/י גישה לכל הפיצ׳רים של Moneytor Premium בחינם!",
            plannerBenefit: "בקבלת ההזמנה תצטרפ/י למשפחה תחת המתכנן הפיננסי",
            acceptInvite: "קבלת ההזמנה",
            declineInvite: "דחיית ההזמנה",
            accepting: "מעבד...",
            errorAccepting: "שגיאה באישור ההזמנה. נסו שנית.",
            errorDeclining: "שגיאה בדחיית ההזמנה. נסו שנית.",
        },
    },
    ENG: {
        myFamily: "My Family",
        inviteMembers: "Invite family members",
        inviteSuccessText: {
            header: "Invitation sent successfully",
            details: "Invitation sent to:",
            button: "Close",
        },
        inviteFailText: {
            header: "Invitation failed",
            details: "Failed to send invitation to",
            button: "Close",
        },
        familyName: "Family name",
        inviteButton: "Invite",
        joinedOn: "Joined on",
        familyMembersTitle: "My family members",
        family: "Family",
        youDontBelongToAFamily: "You are not currently part of a family. To create a family, send an invitation or accept an incoming one",
        save: "Save",
        editFamilyName: "Edit family name",
        invitedOn: "Invited on",
        pendingInvites: "Pending invitations I sent",
        incomingFamilyRequest: "You've been invited to the family of",
        by: "by",
        rejectedInvite: "Invitation rejected for family",
        errorRejectingInvite: "Error rejecting invitation for family",
        acceptedInvite: "Successfully joined the family of",
        errorAcceptingInvite: "Error accepting invitation for family",
        reject: "Reject",
        accept: "Accept",
        familyInvite: {
            header: "Add household member",
            body: "Here you can add your spouse or partner to manage finances together. Send an invitation and ask them to sign in with the same email address. You can cancel sharing at any time.",
            checkboxText: "I confirm that I am sharing my financial information by my own decision with a person with whom I share a household and/or family unit.",
            familyVerificationError: "You must approve this clause to continue",
        },
        familyInviteScreen: {
            title: "You've been invited to join a family!",
            invitedBy: "You were invited by",
            toJoinFamily: "to join the family",
            premiumBenefit: "By accepting, you'll get access to all Moneytor Premium features for free!",
            plannerBenefit: "By accepting, you'll join the family under financial planner",
            acceptInvite: "Accept Invite",
            declineInvite: "Decline Invite",
            accepting: "Processing...",
            errorAccepting: "Error accepting the invite. Please try again.",
            errorDeclining: "Error declining the invite. Please try again.",
        },
    },
    RUS: {
        myFamily: "Моя семья",
        inviteMembers: "Пригласить членов семьи",
        inviteSuccessText: {
            header: "Приглашение успешно отправлено",
            details: "Приглашение отправлено:",
            button: "Закрыть",
        },
        inviteFailText: {
            header: "Не удалось отправить приглашение",
            details: "Не удалось отправить приглашение",
            button: "Закрыть",
        },
        familyName: "Фамилия",
        inviteButton: "Пригласить",
        joinedOn: "Присоединился",
        familyMembersTitle: "Мои члены семьи",
        family: "Семья",
        youDontBelongToAFamily: "Вы сейчас не состоите в семье. Чтобы создать семью, отправьте приглашение или примите входящее",
        save: "Сохранить",
        editFamilyName: "Изменить фамилию",
        invitedOn: "Приглашён",
        pendingInvites: "Отправленные приглашения",
        incomingFamilyRequest: "Вас пригласили в семью",
        by: "от",
        rejectedInvite: "Приглашение отклонено для семьи",
        errorRejectingInvite: "Ошибка при отклонении приглашения для семьи",
        acceptedInvite: "Вы успешно присоединились к семье",
        errorAcceptingInvite: "Ошибка при принятии приглашения для семьи",
        reject: "Отклонить",
        accept: "Принять",
        familyInvite: {
            header: "Добавление члена семьи",
            body: "Здесь вы можете добавить супруга или партнёра для совместного управления финансами. Отправьте приглашение и попросите их войти с тем же адресом электронной почты. Вы можете отменить совместный доступ в любое время.",
            checkboxText: "Я подтверждаю, что по своему решению делюсь своей финансовой информацией с лицом, с которым я веду совместное домохозяйство и/или являюсь членом одной семьи.",
            familyVerificationError: "Необходимо подтвердить этот пункт для продолжения",
        },
        familyInviteScreen: {
            title: "Вас пригласили присоединиться к семье!",
            invitedBy: "Вас пригласил(а)",
            toJoinFamily: "присоединиться к семье",
            premiumBenefit: "Приняв приглашение, вы получите бесплатный доступ ко всем функциям [REDACTED] Премиум!",
            plannerBenefit: "Приняв приглашение, вы присоединитесь к семье под руководством финансового планировщика",
            acceptInvite: "Принять приглашение",
            declineInvite: "Отклонить приглашение",
            accepting: "Обработка...",
            errorAccepting: "Ошибка при принятии приглашения. Попробуйте ещё раз.",
            errorDeclining: "Ошибка при отклонении приглашения. Попробуйте ещё раз.",
        },
    }
}